window.addEventListener("load", () => {
  initMicroModal();
  translator();
  handleMobileNavigation();
  filterObserver();
  handleMobileFilter();
});

function initMicroModal() {
  if (!window.MicroModal) return;

  let lastModalTrigger = null;
  const closeTrigger = "data-micromodal-close";

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest("[data-micromodal-trigger]");
    if (trigger) lastModalTrigger = trigger;
  }, true);

  const releaseFocusOnClose = (event) => {
    if (!(event.target instanceof Element)) return;

    const clickedCloseTrigger = event.target.closest(`[${closeTrigger}]`);
    if (!clickedCloseTrigger) return;

    moveFocusOutOfModal(clickedCloseTrigger.closest("[aria-hidden][id]"));
  };

  document.addEventListener("click", releaseFocusOnClose, true);
  document.addEventListener("touchstart", releaseFocusOnClose, true);

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    moveFocusOutOfModal(document.querySelector(".is-open[aria-hidden='false']"));
  }, true);

  window.MicroModal.init({
    disableScroll: true,
  });

  const initialModal = document.querySelector("[data-micromodal-initial-open]");
  if (initialModal) {
    window.MicroModal.show(initialModal.id, {
      disableScroll: true,
    });
  }

  function moveFocusOutOfModal(modal) {
    if (!modal || !modal.contains(document.activeElement)) return;

    const focusTarget = lastModalTrigger && document.contains(lastModalTrigger)
      ? lastModalTrigger
      : document.body;

    focusTarget.focus?.({ preventScroll: true });

    if (modal.contains(document.activeElement)) {
      document.activeElement.blur();
    }
  }
}

function translator() {
  window.setTimeout(function () {
    if (document.documentElement.lang !== "fr") return;

    var hulkappVolumes = document.querySelector(".hulkapps-volumes");
    if (!hulkappVolumes) return;

    var hulkappItems = hulkappVolumes.querySelectorAll(".table-list-item");

    hulkappItems.forEach(function (item) {
      item.innerHTML = item.innerHTML
        .replace(/Ab /g, "À partir de ")
        .replace(/Stück:/g, "pièces :")
        .replace(/pro Einheit/g, "par pièce");
    });
  }, 500);
}

function handleMobileNavigation() {
  const hamburger = document.querySelector(".hamburger");
  hamburger.addEventListener("click", () => {
    hamburger.classList.toggle("is-active");
  });
}

function filterObserver() {
  const filters = document.querySelectorAll(".filter-items details");
  for (let filter of filters) {
    filter.addEventListener("toggle", (event) => {
      if (filter.open) {
        for (let details of filters) {
          if (details !== event.target) {
            details.removeAttribute("open");
          }
        }
      } else {
        console.log("the element was toggled closed");
      }
    });
  }
}
function handleMobileFilter() {
  const closeFilter = document.querySelector(".all-collections .fa-xmark");
  const openFilter = document.querySelector(".all-collections .mobile-filter");

  if (!openFilter) return;
  if (!closeFilter) return;

  closeFilter.addEventListener("click", () => {
    document
      .querySelector(".box:has(.filter-form)")
      .classList.remove("show-filter");
  });
  openFilter.addEventListener("click", () => {
    document
      .querySelector(".box:has(.filter-form)")
      .classList.add("show-filter");
  });
}
